import { LINK_TEXT_DECORATION } from '../highContrastSx';

export const FOOTER_LIST_SX = {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
};

export const FOOTER_LIST_GRID_SX = {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexWrap: 'wrap',
    rowGap: 1,
};

export const FOOTER_LINK_SX = theme => ({
    color: 'text.secondary',
    textDecoration: LINK_TEXT_DECORATION,
    fontSize: theme.typography.pxToRem(14),
    '&:focus': { color: 'text.secondary' },
    '&:hover': { color: 'primary.main', textDecoration: 'underline' },
});

export const FOOTER_HEADING_SX = theme => ({
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    mt: 0,
});
